module.exports = __webpack_public_path__ + "img/nbv-review.420fa4e6.svg";